import React, { useState } from 'react';
import { TextField, Button, Typography, Container, Box, Link, Paper, IconButton, InputAdornment } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
import logo from '../assets/logo.jpg';
import '../index.css';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${API_URL}/api/login`, { username, password }, { withCredentials: true });
            console.log(API_URL);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            navigate('/home'); // Redirigir al dashboard o página principal
        } catch (error) {
            setError(error.response?.data?.message || 'Usuario o contraseña incorrecta');
        }
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    

    return (
        <Container component="main" maxWidth="xs">
            <Paper elevation={3} sx={{ padding: 4, borderRadius: 2, backgroundColor: '#f6f8e4'}}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <img src={logo} alt="Logo del Consultorio" style={{ width: 100, marginBottom: 20 }} />
                    <Typography component="h1" variant="h5">Bienvenido de nuevo</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ marginBottom: 2 }}>
                        Inicia sesión para continuar
                    </Typography>
                    <form onSubmit={handleLogin} style={{ width: '100%', marginTop: 1 }}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="username"
                            label="Nombre de Usuario o Email"
                            name="username"
                            autoComplete="username"
                            autoFocus
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Contraseña"
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        {error && (
                            <Typography color="error" variant="body2">
                                {error}
                            </Typography>
                        )}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            sx={{ marginTop: 3, marginBottom: 2 }}
                        >
                            Iniciar Sesión
                        </Button>
                    </form>
                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', flexDirection: 'column', alignItems: 'center' }}>
                        <Link component={RouterLink} to="/forgot-password" variant="body2" sx={{ marginBottom: 1 }}>
                            ¿Olvidaste la contraseña?
                        </Link>
                    </Box>
                    <Link component={RouterLink} to="/doctor-signup" variant="body2" sx={{ marginTop: 2 }}>
                        ¿Nuevo en el consultorio? Registrar Médico
                    </Link>
                </Box>
            </Paper>
        </Container>
    );
};

export default Login;